import { cn } from "@/lib/utils";

const LOGO_SRC = "/brand/ekeland-logo.png";
const MARK_SRC = "/brand/ekeland-mark.png";

/** Offisiell wordmark (raud T-sirkel + «Ekeland Transport AS»). Fungerer best på mørk eller lys nøytral flate. */
export const BrandLogo = ({ className, ...props }) => (
  <img
    src={LOGO_SRC}
    alt="Ekeland Transport AS"
    width={1024}
    height={381}
    decoding="async"
    className={cn("h-auto w-auto select-none", className)}
    draggable={false}
    {...props}
  />
);

/** Berre sirkelmerket – til topbar, sidebar og favicon-liknande bruk. */
export const BrandMark = ({ className, ...props }) => (
  <img
    src={MARK_SRC}
    alt=""
    aria-hidden="true"
    width={270}
    height={270}
    decoding="async"
    className={cn("h-8 w-8 select-none", className)}
    draggable={false}
    {...props}
  />
);

/** Kompakt merkevare-rad: merke + namn. */
export const BrandLockup = ({ className, compact = false, dark = false, testId = "brand-lockup" }) => (
  <div className={cn("flex min-w-0 items-center gap-2.5", className)} data-testid={testId}>
    <BrandMark className={compact ? "h-7 w-7" : "h-8 w-8"} />
    <div className="flex min-w-0 items-center gap-2">
      <span className={cn("truncate font-semibold tracking-tight", compact ? "text-[15px]" : "text-base", dark ? "text-white" : "text-foreground")}>
        Ekeland Transport
      </span>
    </div>
  </div>
);
